export default __webpack_public_path__ + "static/media/driver.3479db64.png";